/**
 * Guide HTML from CKEditor often has <table>/<td>/<th> with no border attribute
 * or inline border styles. Adds tasteful defaults; user styles are merged last
 * so they override ours on the same property.
 */

function styleHasBorder(style) {
  if (!style || typeof style !== 'string') return false;
  return /\bborder(-[a-z]+)?\s*:/i.test(style);
}

function mergeStyle(el, snippet) {
  const cur = (el.getAttribute('style') || '').trim();
  el.setAttribute('style', cur ? `${snippet}; ${cur}` : snippet);
}

const TABLE_DEFAULT =
  'border-collapse: collapse; width: 100%; max-width: 100%; margin: 16px 0; border: 1px solid #CBD5E1; box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06), 0 4px 12px rgba(15, 23, 42, 0.04)';

const TD_DEFAULT =
  'border: 1px solid #E2E8F0; padding: 12px 14px; vertical-align: top';

const TH_DEFAULT =
  'border: 1px solid #E2E8F0; padding: 12px 14px; vertical-align: top; background-color: #F8FAFC; color: #0F172A; font-weight: 600';

export function normalizeGuideTableHtml(html) {
  if (!html || typeof html !== 'string') return html;
  try {
    const tpl = document.createElement('template');
    tpl.innerHTML = html;
    const root = tpl.content;
    root.querySelectorAll('table').forEach((table) => {
      const hasBorderAttr = table.hasAttribute('border');
      if (!hasBorderAttr && !styleHasBorder(table.getAttribute('style'))) {
        mergeStyle(table, TABLE_DEFAULT);
      }
      table.querySelectorAll('th').forEach((cell) => {
        if (!styleHasBorder(cell.getAttribute('style'))) {
          mergeStyle(cell, TH_DEFAULT);
        }
      });
      table.querySelectorAll('td').forEach((cell) => {
        if (!styleHasBorder(cell.getAttribute('style'))) {
          mergeStyle(cell, TD_DEFAULT);
        }
      });
    });
    return tpl.innerHTML;
  } catch (e) {
    return html;
  }
}
